import { get as lget } from 'lodash';

import { FormItem } from '@ingrid/luterkort-react';

import { ValidationError } from '~src/components/ValidationError/ValidationError';

import { useCarrierContractFormContext } from '../../types';
import { Schema } from '../queries';

interface Props {
  schema: Schema;
  path?: string;
}

export function SchemaFormSubText({ schema, path = '' }: Props) {
  const { formState } = useCarrierContractFormContext();

  /**
   * Indicates that we have no validation errors
   */
  if (!lget(formState.errors, path) && schema.description) {
    return <FormItem.HintText>{schema.description}</FormItem.HintText>;
  }

  return <ValidationError errors={formState.errors} name={path} />;
}
